/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type CashActivityDetails_viewer$ref: FragmentReference;
declare export opaque type CashActivityDetails_viewer$fragmentType: CashActivityDetails_viewer$ref;
export type CashActivityDetails_viewer = {|
  +cashSummaries: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +summaryDatetime: ?any,
        +reportDate: ?any,
        +description: ?string,
        +cashDeltas: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +quantity: number,
              +currency: Currency,
              +createdAt: any,
              +updatedAt: any,
            |}
          |}>
        |},
        +availableCashDeltas: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +quantity: number,
              +currency: Currency,
              +createdAt: any,
              +updatedAt: any,
            |}
          |}>
        |},
        +cashBalances: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +currency: Currency,
              +quantity: number,
            |}
          |}>
        |},
        +availableCashBalances: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +currency: Currency,
              +quantity: number,
            |}
          |}>
        |},
        +endingCashBase: ?number,
      |}
    |}>,
    +count: ?number,
  |},
  +$refType: CashActivityDetails_viewer$ref,
|};
export type CashActivityDetails_viewer$data = CashActivityDetails_viewer;
export type CashActivityDetails_viewer$key = {
  +$data?: CashActivityDetails_viewer$data,
  +$fragmentRefs: CashActivityDetails_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "createdAt",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "updatedAt",
    "args": null,
    "storageKey": null
  }
],
v4 = [
  (v0/*: any*/),
  (v2/*: any*/),
  (v1/*: any*/)
];
return {
  "kind": "Fragment",
  "name": "CashActivityDetails_viewer",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "cashSummaryId",
      "type": "ID",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cashSummaries",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "cashSummaryId"
        }
      ],
      "concreteType": "CashSummaryNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CashSummaryNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CashSummaryNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "summaryDatetime",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "reportDate",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "cashDeltas",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CashDeltaNodeConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "CashDeltaNodeEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "CashDeltaNode",
                          "plural": false,
                          "selections": (v3/*: any*/)
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "availableCashDeltas",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "AvailableCashDeltaNodeConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "AvailableCashDeltaNodeEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "AvailableCashDeltaNode",
                          "plural": false,
                          "selections": (v3/*: any*/)
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "cashBalances",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CashBalanceNodeConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "CashBalanceNodeEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "CashBalanceNode",
                          "plural": false,
                          "selections": (v4/*: any*/)
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "availableCashBalances",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "AvailableCashBalanceNodeConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "AvailableCashBalanceNodeEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "AvailableCashBalanceNode",
                          "plural": false,
                          "selections": (v4/*: any*/)
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "endingCashBase",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "count",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '2ecd5d987d949ee5b15248fc67d42ae4';
module.exports = node;
